module.exports = __webpack_public_path__ + "static/img/abstract.9586fad6.png";